import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiHome, FiFileText, FiKey } = FiIcons;

const Process = () => {
  const phoneNumber = "251-522-9131";
  
  const steps = [
    {
      icon: FiPhone,
      title: "Call or Text Tyler",
      description: `Contact Tyler directly at ${phoneNumber}. No automated systems, no gatekeepers—just a quick chat about your house.`
    },
    {
      icon: FiHome,
      title: "Quick Walkthrough",
      description: "Tyler will schedule a brief 15-minute visit to see your property. You don't need to clean or fix a single thing."
    },
    {
      icon: FiFileText,
      title: "Firm Cash Offer",
      description: "Within 24 hours of the visit, Tyler will give you a firm, all-cash offer. What you see is what you get—no hidden fees."
    },
    {
      icon: FiKey,
      title: "Get Your Cash",
      description: "Pick your closing date. Tyler handles all the paperwork and closing costs. Walk away with cash in hand."
    }
  ];

  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Easy Way to Sell
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Working with Tyler is simple. No agents, no showings, and no waiting months for a buyer.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center relative"
            >
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center font-bold text-sm z-10 shadow-lg">
                {index + 1}
              </div>
              <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 h-full border border-gray-100">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <SafeIcon icon={step.icon} className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h3 className="text-2xl font-semibold text-gray-900 mb-6">
            Ready for your offer?
          </h3>
          <motion.a
            href={`tel:${phoneNumber}`}
            className="inline-flex items-center space-x-3 bg-red-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-red-700 transition-colors shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={FiPhone} className="w-6 h-6" />
            <span>Call Tyler at {phoneNumber}</span>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Process;